<div class="main-wrapper">
    <app-navbar></app-navbar>
    @if(isLoggedin) {
    <div class="h-1">
        <app-loading-indicator></app-loading-indicator>
    </div>
    }
    <app-notifications></app-notifications>
    <router-outlet>
    </router-outlet>
    <app-footer></app-footer>
</div>
